import {createTheme as baseCreateTheme} from 'quickstart/theme/base'
import {FontName} from 'quickstart/theme/types'
import {BlockContext, Dict} from 'quickstart/types'
import {logger} from 'tizra'
import {
  ThemeBlockGlobalConfig,
  defaultGlobalConfig,
  globalMigrate,
} from './admin'

const log = logger('quickstart/blocks/ThemeBlock')

const hexy = (s: string) => /^#?(?:[\da-f]{3}){1,2}$/i.test(s)

const hash = (s: string) => s.replace(/^#?/, '#')

const fonts: Dict<FontName> = {
  sans: 'Merriweather Sans',
  serif: 'Merriweather',
}

/**
 * Create the theme for passing to ThemeProvider. The structure passed to
 * createTheme() from quickstart/theme is the set of overrides. The overrides
 * from ThemeBlock fall under the branding key.
 */
export const createBrandedTheme = ({context}: {context: BlockContext}) => {
  const globalConfig = globalMigrate({
    globalConfig: context.globalConfig.theme,
    hacks: context.hacks,
  })

  const branding: Dict<any> = {
    bodyFont: fonts[globalConfig.bodyFont] ?? fonts.sans,
    headingFont: fonts[globalConfig.headingFont] ?? fonts.sans,
  }

  for (const k of ['buttonColor', 'linkColor'] as Array<
    keyof ThemeBlockGlobalConfig
  >) {
    if (!(k in defaultGlobalConfig)) {
      log.warn(`${k} not in defaultGlobalConfig`)
      continue
    }
    branding[k] = defaultGlobalConfig[k]
    if (globalConfig[k]) {
      if (hexy(globalConfig[k])) {
        branding[k] = hash(globalConfig[k])
      } else {
        log.warn(
          `${k} doesn't match required hex color format #NNN or #NNNNNN, ignoring`,
        )
      }
    }
  }

  return baseCreateTheme({branding})
}
